import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { EyeOff, Eye } from "lucide-react";
import { toast } from "sonner";

const VIS_LABEL = { community: "Community", anonymous: "Anonymous", listeners: "Only to listeners" };

export default function AdminTestimonies() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/admin/testimonies").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const toggle = async (id) => {
    try { await api.post(`/admin/testimonies/${id}/hide`); load(); toast.success("Updated."); } catch {}
  };

  return (
    <div>
      <h1 className="font-heading text-3xl tracking-tight mb-2">Testimonies</h1>
      <p className="text-muted-foreground mb-8 text-sm">Moderate with care. You can hide a testimony when necessary, out of respect for people.</p>
      <div className="space-y-3" data-testid="admin-testimonies-list">
        {items.map((t) => (
          <div key={t.id} className={`bg-card border rounded-2xl p-5 ${t.hidden ? "border-destructive/40 opacity-70" : "border-border"}`}>
            <div className="flex items-start justify-between gap-4">
              <div>
                {t.title && <p className="font-heading text-lg">{t.title}</p>}
                <p className="text-muted-foreground text-sm line-clamp-2 mt-1">{t.body}</p>
                <p className="text-xs text-accent mt-2">— {t.author_name} · {VIS_LABEL[t.visibility] || t.visibility}{t.hidden ? " · hidden" : ""}</p>
              </div>
              <Button variant="outline" size="sm" className="rounded-full shrink-0" onClick={() => toggle(t.id)} data-testid={`toggle-hide-${t.id}`}>
                {t.hidden ? <><Eye className="w-4 h-4 mr-1" /> Show</> : <><EyeOff className="w-4 h-4 mr-1" /> Hide</>}
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
